import * as React from "react";
import { Message, MessageContent, MessageHeader } from "semantic-ui-react";
import { WithTranslation, withTranslation } from 'react-i18next';

class BrowserAlert extends React.Component<WithTranslation> {
    render() {
        return (
            <React.Fragment>
                <Message id="alert" negative={true}>
                    <MessageHeader>{this.props.t('browserAlert.header')}</MessageHeader>
                    <MessageContent>{this.props.t('browserAlert.content')} <a target="_blank" href="https://entralpi.com/pages/quickstart">{this.props.t('browserAlert.guideLink')}</a></MessageContent>
                </Message>
            </React.Fragment>
        );
    }
}

export default withTranslation('common')(BrowserAlert);
